import { render } from "./SpinnerBetter.vue?vue&type=template&id=7f01bce9"
import script from "./SpinnerBetter.vue?vue&type=script&lang=js"
export * from "./SpinnerBetter.vue?vue&type=script&lang=js"

import "./SpinnerBetter.vue?vue&type=style&index=0&id=7f01bce9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SpinnerBetter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f01bce9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f01bce9', __exports__)) {
    api.reload('7f01bce9', __exports__)
  }
  
  module.hot.accept("./SpinnerBetter.vue?vue&type=template&id=7f01bce9", () => {
    api.rerender('7f01bce9', render)
  })

}


export default __exports__